import usePageMessage from '@/hooks/exception/usePageMessage'
import { ElMessage } from 'element-plus'
import { sleep } from '.'

const baseUrl = process.env.VUE_APP_BFF_BASE_URL //

const request = function (apiKey, data) {
  var promise = new Promise((resolve, reject) => {
    if (!config.requestApi[apiKey]) {
      reject('api is not exist')
    }
    var api = config.requestApi[apiKey]

    for (var i in data) {
      if (typeof data[i] == 'object') {
        data[i] = encodeURIComponent(JSON.stringify(data[i]))
      }
    }

    var headers = {
      Accept: '*/*',
      'X-Requested-With': 'XMLHttpRequest',
      Authorization: 'Bearer ' + sessionStorage.getItem('token'),
      'Content-Type': 'application/json',
    }

    if (api.method == 'get') {
      axios
        .get(baseUrl + api.url, { params: data, headers })
        .then((rel) => {
          resolve(rel.data)
        })
        .catch((err) => {
          console.log(err)
          reject('network error')
        })
    } else {
      var params = []
      for (i in data) {
        params.push(i + '=' + data[i])
      }

      axios
        .post(baseUrl + api.url, data, { headers })
        .then((rel) => {
          resolve(rel.data)
        })
        .catch((err) => {
          console.log(err)
          reject('network error')
        })
    }
  })
  return promise
}

/**
 * 右上のメッセージを表示
 * @param message メッセージ内容
 * @param status 'error' or 'success'
 */
function errorMessage(message, status) {
  const { ballonMessageLastType, setBallonMessageLastType } = usePageMessage()
  ballonMessageLastType.value === 'error' && ElMessage.closeAll()
  setBallonMessageLastType(status)

  sleep(20).then(() => {
    ElMessage({
      showClose: true,
      message,
      duration: 0,
      offset: 5,
      type: status, // 'error' or 'success'
    })
  })
}

/**
 * 右上のメッセージをすべてを閉じる
 */
function closeAllErrorMessage() {
  ElMessage.closeAll()
}

//受領状態判定
const getReceiveStatus = (role_code, historyStatus, statusStatus) => {
  if (role_code === '05') {
    //3無料プラン
    return 3
  } else if (historyStatus === '04') {
    //4 送信取消
    return 4
  } else if (historyStatus === '01' && statusStatus === '02') {
    //1 受領済み
    return 1
  } else if (historyStatus === '01' && statusStatus === '03') {
    //2 受領拒否
    return 2
  } else if (historyStatus === '01' && !statusStatus) {
    //0 未受領
    return 0
  } else {
    return -1
  }
}

//大きな数字を3位毎に「,」を付ける
const toThousands = (num) => {
  return num.toString().replace(/\d+/, function (n) {
    return n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
  })
}

const getFullTimestamp = () => {
  var date = new Date()
  var YY = date.getFullYear()
  var MM = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  var DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  var hh = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  var mm = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  var ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  return (
    YY.toString() +
    MM.toString() +
    DD.toString() +
    hh.toString() +
    mm.toString() +
    ss.toString()
  )
}
export {
  request,
  baseUrl,
  errorMessage,
  closeAllErrorMessage,
  getReceiveStatus,
  toThousands,
  getFullTimestamp,
}
